import { createAction, handleActions } from "redux-actions";
//
import { _addIf } from "../utils";
import { BOOKING_GENDER_SET } from "./booking/actions";
import { MODAL_SCREEN_SHOW, MODAL_HIDE } from "./modal/actionTypes";
import { countModelsAction } from "./models/actions";

// ----------------------------------------------------------------------------------------------------------------------------
//  Actions
// ----------------------------------------------------------------------------------------------------------------------------
const FILTER_SET = "filters/FILTER_SET";
const FILTER_SERVICE_TOGGLE = "filters/FILTER_SERVICE_TOGGLE";
export const FILTERS_CANCEL = "filters/FILTERS_CANCEL";
const FILTER_REMOVE = "filters/FILTER_REMOVE";
const FILTER_ORDER_SET = "filters/FILTER_ORDER_SET";
//
const _setFilterAction = createAction(FILTER_SET, (name, value) => ({
  name,
  value,
}));
const _toggleServiceFilterAction = createAction(FILTER_SERVICE_TOGGLE);
export const cancelFiltersAction = createAction(FILTERS_CANCEL);
export const removeFilterAction = createAction(FILTER_REMOVE);
export const setOrderByAction = createAction(FILTER_ORDER_SET);

export function setFilterAction(name, value) {
  return (dispatch, getState) => {
    dispatch(_setFilterAction(name, value));

    return dispatch(countModelsAction());
  };
}

export function toggleServiceFilterAction(serviceId) {
  return (dispatch, getState) => {
    dispatch(_toggleServiceFilterAction(serviceId));

    return dispatch(countModelsAction());
  };
}

// ----------------------------------------------------------------------------------------------------------------------------
//  Reducer
// ----------------------------------------------------------------------------------------------------------------------------
const initialState = {
  values: {
    brandId: "",
    ageType: "",
    ageMin: null,
    ageMax: null,
    heightType: "",
    heightMin: null,
    heightMax: null,
    endowment: "",
    orientation: "",
    cup: "",
    services: [],
    ageVerified: false,
  },
  old: {},
  orderRaw: "",
  orderBy: "",
  orderDir: "",
  genderId: 1, // Female
};

export default handleActions(
  {
    [MODAL_SCREEN_SHOW]: applyShowScreen,
    [FILTER_SET]: applySetFilter,
    [FILTER_REMOVE]: applyRemoveFilter,
    [FILTERS_CANCEL]: applyCancelFilters,
    [BOOKING_GENDER_SET]: applyGender,
    [MODAL_HIDE]: applyReset,
    [FILTER_SERVICE_TOGGLE]: applyToggleService,
    [FILTER_ORDER_SET]: applySetOrderBy,
  },
  initialState
);

// ----------------------------------------------------------------------------------------------------------------------------
//  Action Reducers
// ----------------------------------------------------------------------------------------------------------------------------
function applyShowScreen(state, action) {
  if (action.payload === "filters") {
    return {
      ...state,
      old: state.values,
    };
  } else if (action.payload === "duration") {
    return initialState;
  }

  return state;
}

function applySetFilter(state, action) {
  const { values: oldValues } = state;
  const { name, value } = action.payload;

  const values = {
    ...oldValues,
    [name]: value,
  };

  if (value) {
    if (name === "brandId") {
      if (value !== "independent") {
        values.brandId = parseInt(value);
      }
    }

    if (name === "endowment" && value === "post-op") {
      values.orientation = "";
    }

    if (name === "heightType") {
      if (value === "short") {
        values.heightMin = null;
        values.heightMax = 156;
      } else if (value === "tall") {
        values.heightMin = 165;
        values.heightMax = null;
      } else if (value === "average") {
        values.heightMin = 156;
        values.heightMax = 165;
      }
    }

    if (name === "ageType") {
      const ages = value.split("-");

      values.ageMin = ages[0];

      if (ages[1]) {
        values.ageMax = ages[1];
      }
    }
  } else {
    if (name === "heightType") {
      values.heightMin = null;
      values.heightMax = null;
    }
    if (name === "ageType") {
      values.ageMin = null;
      values.ageMax = null;
    }
  }

  return {
    ...state,
    values,
  };
}

function applyRemoveFilter(state, action) {
  const { values: oldValues } = state;
  const name = action.payload;
  const value = name === "services" ? [] : "";

  return {
    ...state,
    values: { ...oldValues, [name]: value },
  };
}

function applyCancelFilters(state, action) {
  const { old } = state;

  return {
    ...state,
    values: { ...old },
    old: {},
  };
}

function applyGender(state, action) {
  return {
    ...initialState,
    genderId: action.payload,
  };
}

function applyReset(state, action) {
  return initialState;
}

function applyToggleService(state, action) {
  const { values: oldValues } = state;
  const services = _addIf(oldValues.services, action.payload);

  return {
    ...state,
    values: { ...oldValues, services },
  };
}

function applySetOrderBy(state, action) {
  const orderRaw = action.payload;

  let orderBy;
  let orderDir;

  if (orderRaw) {
    let parts = orderRaw.split("_");

    orderBy = parts[0];
    orderDir = parts[1];
  } else {
    orderBy = "";
    orderDir = "";
  }

  return {
    ...state,
    orderRaw,
    orderBy,
    orderDir,
  };
}
